import script from "./ActivityGeneralForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityGeneralForm.vue?vue&type=script&setup=true&lang=js"

import "./ActivityGeneralForm.vue?vue&type=style&index=0&id=6d06fceb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d06fceb"]])

export default __exports__